import { createContext } from 'react';
import {
  DataRoomRFI,
  DataRoomRfiTemplate,
  FileTypeRFI,
} from '../../models/DataRoomRfi';
import utils from 'utils';

type RfiContextProps = {
  isLoading: boolean;
  isLoadingTemplates: boolean;
  pending: DataRoomRFI[];
  submitted: DataRoomRFI[];
  closed: DataRoomRFI[];
  rfis: DataRoomRFI[];
  rfiTemplates: DataRoomRfiTemplate[];
  idsOfUpdatedSubmitted: string[];
  refetch: () => void;
  refetchTemplates: () => void;
  addRfi: (rfi: DataRoomRFI) => void;
  updateRfi: (updatedRfi: Partial<DataRoomRFI>) => void;
  updateRfiFile: (rfiId: string, file: FileTypeRFI) => void;
  updateRfiFiles: (rfiId: string, files: FileTypeRFI[]) => void;
  sortFiles: (rfiId: string, sort: string) => void;
  getRfiById: (rfiId: string) => DataRoomRFI;
  getIsNew: (rfiId: string, date: Date) => boolean;
  viewRfi: (rfiId: string) => void;
  deleteTemplate: (_id: string) => void;
};

export default createContext<Partial<RfiContextProps>>({
  isLoading: false,
  isLoadingTemplates: false,
  pending: [],
  submitted: [],
  closed: [],
  rfis: [],
  rfiTemplates: [],
  idsOfUpdatedSubmitted: [],
  refetch: utils.noop,
  refetchTemplates: utils.noop,
  addRfi: utils.noop,
  updateRfi: utils.noop,
  updateRfiFile: utils.noop,
  updateRfiFiles: utils.noop,
  sortFiles: utils.noop,
  getRfiById: utils.noop,
  getIsNew: utils.noop,
  viewRfi: utils.noop,
  deleteTemplate: utils.noop,
});
